"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterFontsWithLanguage = exports.orderFamily = exports.mapFonts = exports.separateNumberAndString = void 0;
function separateNumberAndString(input) {
    const match = input.match(/^(\d+)(\D*)$/);
    if (match) {
        const numberPart = parseInt(match[1], 10);
        const stringPart = match[2] || '';
        return { number: numberPart, text: stringPart };
    }
    else {
        return { number: 400, text: input };
    }
}
exports.separateNumberAndString = separateNumberAndString;
function mapFonts(font) {
    const italicRegex = /italic/i;
    const variants = font.support.i
        ? font.support.variants
        : font.support.variants.filter((variant) => !italicRegex.test(variant));
    return {
        family: font.family,
        support: {
            b: font.support.b,
            bi: font.support.bi,
            i: font.support.i,
        },
        subsets: font.support.subsets,
        variants,
    };
}
exports.mapFonts = mapFonts;
function orderFamily(a, b) {
    return a.family.localeCompare(b.family);
}
exports.orderFamily = orderFamily;
function filterFontsWithLanguage(font, language) {
    var _a;
    if (language === 'default')
        return true;
    const subsets = (_a = font.support) === null || _a === void 0 ? void 0 : _a.subsets;
    return subsets ? font.support.subsets.includes(language) : false;
}
exports.filterFontsWithLanguage = filterFontsWithLanguage;
//# sourceMappingURL=FontFamily.utils.js.map